import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Card, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import numeral from 'numeral';
import defaultLogo from '../../Images/logo.svg';
import { selecionaImobiliaria } from '~/Store/Produtividade/actions';

class CardResumoImobiliaria extends Component {
  formataVlResumo = valor => numeral(valor).format('(R$ 0.00 a)');

  formataCurrency = valor => {
    if (valor) {
      return valor.toLocaleString('pt-BR');
    }
    return '0,00';
  };

  getRankingMedal = rank => {
    const medals = {
      1: { emoji: 1, class: 'ranking-gold' },
      2: { emoji: 2, class: 'ranking-silver' },
      3: { emoji: 3, class: 'ranking-bronze' },
    };
    return medals[rank] || { emoji: rank, class: 'ranking-default' };
  };

  getTopCorretores = imobiliariaCodigo => {
    const { ranking_corretores } = this.props;
    const corretores = ranking_corretores[imobiliariaCodigo];

    if (!corretores || !Array.isArray(corretores)) {
      return [];
    }

    return corretores.filter(c => !c.label).slice(0, 3);
  };

  getCorretorNome = corretor => {
    if (corretor && corretor.nome) {
      const partes = corretor.nome.split(' ');
      return partes[0];
    }
    return 'Corretor';
  };

  render() {
    const { imobiliarias, imobiliariaSelecionada } = this.props;

    if (imobiliariaSelecionada) return null;

    return (
      <div className="CardResumoImobiliariaV2 mb-4">
        {imobiliarias.map((imobiliaria, index) => {
          const medalInfo = this.getRankingMedal(imobiliaria.rank);
          const topCorretores = this.getTopCorretores(imobiliaria.codigo);

          return (
            <div
              className="ImobiliariaItemV2"
              key={imobiliaria.codigo}
              id={`card_reumo_imobiliaria_${index}`}
            >
              <Card className="border-0 shadow-sm">
                <div className="d-flex flex-column flex-md-row">
                  <Col
                    xs={12}
                    md={8}
                    className="d-flex flex-column flex-md-row align-items-center p-3"
                  >
                    <div className="imob-identity d-flex flex-column align-items-center">
                      <div className={`ranking-badge ${medalInfo.class}`}>
                        <span className="ranking-number">
                          {imobiliaria.rank}º
                        </span>
                      </div>
                      <button
                        onClick={() =>
                          this.props.selecionaImobiliaria(imobiliaria)
                        }
                        className="btn-logo-imob"
                      >
                        <div className="logo-circle">
                          <img
                            src={
                              imobiliaria.url_imagem
                                ? imobiliaria.url_imagem
                                : defaultLogo
                            }
                            title={imobiliaria.nome}
                            alt={imobiliaria.nome}
                          />
                        </div>
                      </button>
                      <span className="imob-name">{imobiliaria.nome}</span>
                    </div>

                    <div className="dados-financeiros flex-grow-1">
                      <ul className="list-unstyled d-flex flex-wrap justify-content-center justify-content-md-start">
                        <li>
                          <small className="d-block">VGV</small>
                          <strong
                            className="d-block"
                            title={
                              'R$ ' + this.formataCurrency(imobiliaria.vendas)
                            }
                          >
                            <small>R$</small>
                            {this.formataVlResumo(imobiliaria.vendas)}
                          </strong>
                        </li>
                        <li>
                          <small className="d-block">Recebíveis</small>
                          <strong
                            className="d-block"
                            title={
                              'R$ ' +
                              this.formataCurrency(imobiliaria.recebiveis)
                            }
                          >
                            <small>R$</small>
                            {this.formataVlResumo(imobiliaria.recebiveis)}
                          </strong>
                        </li>
                        <li>
                          <small className="d-block">Comissão</small>
                          <strong
                            className="d-block"
                            title={
                              'R$ ' +
                              this.formataCurrency(imobiliaria.comissao_total)
                            }
                          >
                            <small>R$</small>
                            {this.formataVlResumo(imobiliaria.comissao_total)}
                          </strong>
                        </li>
                        <li>
                          <small className="d-block">Qtd. Vendas</small>
                          <strong
                            className="d-block"
                            title="E = Vendas Efetivadas / P = Proposta Rápida"
                          >
                            {imobiliaria.quantidade_vendas}
                            <span className="vendas-detail">
                              (E:{imobiliaria.quantidade_efetivadas}+P:
                              {imobiliaria.quantidade_propostas_rapidas})
                            </span>
                          </strong>
                        </li>
                        <li>
                          <small className="d-block">Em aberto</small>
                          <strong
                            className="d-block"
                            title={
                              'R$ ' +
                              this.formataCurrency(
                                imobiliaria.recebiveis_em_aberto
                              )
                            }
                          >
                            <small>R$</small>
                            {this.formataVlResumo(
                              imobiliaria.recebiveis_em_aberto
                            )}
                          </strong>
                        </li>
                        <li>
                          <small className="d-block">VGV Rescisões</small>
                          <strong
                            className="d-block"
                            title={
                              'R$ ' +
                              this.formataCurrency(imobiliaria.rescisoes)
                            }
                          >
                            <small>R$</small>
                            {this.formataVlResumo(imobiliaria.rescisoes)}
                          </strong>
                        </li>
                        <li>
                          <small className="d-block">Já baixado</small>
                          <strong
                            className="d-block"
                            title={
                              'R$ ' +
                              this.formataCurrency(
                                imobiliaria.recebiveis_baixados
                              )
                            }
                          >
                            <small>R$</small>
                            {this.formataVlResumo(
                              imobiliaria.recebiveis_baixados
                            )}
                          </strong>
                        </li>
                        <li className="conversao-item">
                          <small className="d-block">Cadastros</small>
                          <strong className="d-block">
                            {imobiliaria.quantidade_atendimentos_leads}
                          </strong>
                        </li>
                        <li className="conversao-item">
                          <small className="d-block">Taxa de conversão</small>
                          <strong className="d-block taxa-valor">
                            {numeral(
                              imobiliaria.conversao_periodo /
                                imobiliaria.quantidade_atendimentos_leads
                            ).format('(0.00%)')}
                          </strong>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col xs={12} md={4} className="podio-section">
                    <div className="podio-header">
                      <span>Top Corretores</span>
                    </div>
                    <div className="podio-corretores">
                      {topCorretores.map((corretor, idx) => {
                        const posicao = idx + 1;
                        const podioClass =
                          posicao === 1
                            ? 'primeiro'
                            : posicao === 2
                            ? 'segundo'
                            : 'terceiro';
                        return (
                          <div
                            key={idx}
                            className={'corretor-podio ' + podioClass}
                          >
                            <div className="corretor-avatar">
                              <img
                                src={
                                  corretor.url_imagem
                                    ? corretor.url_imagem
                                    : defaultLogo
                                }
                                alt={corretor.nome}
                                title={corretor.nome}
                              />
                            </div>
                            <span
                              className="corretor-nome"
                              title={corretor.nome}
                            >
                              {this.getCorretorNome(corretor)}
                            </span>
                            <div className="podio-bar">{posicao}º</div>
                          </div>
                        );
                      })}
                      {topCorretores.length === 0 && (
                        <div className="sem-corretores">
                          <span>Sem corretores</span>
                        </div>
                      )}
                    </div>
                  </Col>
                </div>
              </Card>
            </div>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  imobiliarias: state.produtividade.imobiliarias,
  ranking_corretores: state.produtividade.imobiliarias.reduce(
    (Ranking, imob) => {
      Ranking[imob.codigo] = imob.ranking_corretores || [];
      return Ranking;
    },
    {}
  ),
  imobiliariaSelecionada: state.produtividade.imobiliariaSelecionada,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      selecionaImobiliaria,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CardResumoImobiliaria)
);
